<!--
 * @Author: kongxiangyu
 * @Date: 2022-11-19 17:59:53
 * @LastEditTime: 2023-02-11 08:56:28
 * @email: kongxiangyu@cd.baidu.com
 * @Description: Do not edit
-->
<template>
    <div v-if="dataSource.card_data" id="packet">
        <div class="main">
            <div
                v-for="(item,index) in dataSource.card_data.coupon_list"
                :key="item.bdmap_coupon_id"
                class="coupon"
            >
                <div class="priceBox">
                    <div>
                        <span class="coupon_unit">¥</span>
                        <span class="coupon_price">{{ item.discount_amount }}</span>
                    </div>
                </div>

                <span class="coupon_limit">{{ item.use_rule_str }}</span>
                <span class="coupon_amount">{{ '仅剩' + item.stock_left + '张' }}</span>
                <div class="right">
                    <img
                        :src="getBtnImage(item)"
                        alt=""
                        @click="handleAction(couponTypeMap['btn'][item.code_status]['action'],item,index)"
                    >
                </div>

            </div>
        </div>
        <div class="bottom"></div>
    </div>
</template>

<script>

import Const from '../../../constant/Constant';
import Server from '../../../service.js';
import {getParamsFromUrl} from '@baidu/map-fe-utils';
import EventBus from '../../../constant/EventBus.js';
import StatisticConst from '../../../constant/StatisticConst.js';
export default {
    props: {
        dataSource: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            couponTypeMap: Const.couponTypeMap
        };
    },
    created() {
        StatisticConst.freeMsShow();
    },
    watch: {
        dataSource: {
            handler(val) {
                if (val.card_data) {
                    val.card_data.coupon_list.forEach(item => {
                        if (item.stock_left === 0) {
                            item.code_status = 101;
                        }
                    });
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        getBtnImage(item) {
            if (item.stock_left === 0) {
                return this.couponTypeMap.btn['101'].btn;
            }
            return this.couponTypeMap.btn[item.code_status].btn;
        },
        /**
         * 点击优惠券右侧按钮
         * @param {String} action  'get'去领取，'jump'美食跳转锚点&加油跳转链接，''无动作
         * 加油跳转 baidumap://map/place/search?src=PoiSecListPG&popRoot=no&ext_pagestatus=full&query=加油站&pretab_param=%7B%22pl_data_type%22%3A%22refuel%22%2C%22fp_tab_filter%22%3A%22gs_tab_2%22%7D&ext_src=yushou
         */
        handleAction(type, item, i) {
            if (type === 'get') {
                this.getPacket(item.bdmap_coupon_id, item);
            }
            else if (type === 'jump') {
                if (item.app_id === 5) {
                    // 修改锚点
                    if (i === 0) {
                        document.querySelector('#hot').scrollIntoView({
                            behavior: 'smooth'
                        });
                    }
                    else {
                        document.querySelector('#sale').scrollIntoView({
                            behavior: 'smooth'
                        });
                    }

                }
                else if (item.app_id === 100) {
                    window.location.href = 'baidumap://map/place/search?src=PoiSecListPG&popRoot=no&ext_pagestatus=full&query=加油站&pretab_param=%7B%22pl_data_type%22%3A%22refuel%22%2C%22fp_tab_filter%22%3A%22gs_tab_2%22%7D&ext_src=yushou';
                }
            }
            else {
                return;
            }
        },
        getPacket(id, item) {
            if (item.app_id === 5) {
                StatisticConst.freeMsClick();
            }
            else {
                StatisticConst.freeJyClick();
            }
            const params = {
                app_id: '20230206',
                activity_id: getParamsFromUrl().activity_id,
                cuid: getParamsFromUrl().cuid,
                city_id: getParamsFromUrl().c || 0,
                bdmap_coupon_ids: id,
                room_id: this.dataSource.room_id
            };

            // eslint-disable-next-line @babel/new-cap
            Server('PacketRevive', params)
                .then(res => {
                    try {
                        if (res && res.errno === 0) {
                            this.$toast('领取成功');
                            EventBus.$emit('tplRefresh', this.dataSource.room_id);
                        }
                        else if (res && res.errno === 4003) {
                            EventBus.$emit('jointLogin');
                        }
                        else {
                            this.$toast(res.msg);
                        }
                    }
                    catch (e) {
                        console.error('error', e);
                    }
                })
                .catch(e => {
                    console.error('error', e);
                });
        }

    }
};
</script>

<style lang="scss" scoped>
    #packet{
        width:100%;
        position:relative;
        top:-1px;
        .main{
            width:calc(100% - 34px);
            height:175px;
            background-image: url('../../../assets/middle.png');
            background-size: 100% 100%;
            padding:0 12px;
            margin:0 auto;
            display:flex;
            flex-direction: column;
            justify-content: space-between;
            .coupon{
                height:85px;
                background-image: url('../../../assets/coupon.png');
                background-size: 100% 100%;
                position:relative;
                .priceBox{
                    height: 100%;
                    width: 100px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .coupon_unit{
                        font-size: 12px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #FF4000;
                    }
                    .coupon_price{
                        font-size: 40px;
                        font-family: FZZhengHeiS-EB-GB;
                        font-weight: 600;
                        color: #FF4000;
                    }
                }

                .coupon_limit{
                    font-size: 15px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #FF4000;
                    position:absolute;
                    top:23px;
                    left:100px;
                    white-space: nowrap;
                }
                .coupon_amount{
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #9E461C;
                    position:absolute;
                    top:45px;
                    left:100px;
                    white-space: nowrap;
                }
                .right{
                    width:112px;
                    height:100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    position:absolute;
                    right:0;
                    top:0;
                    .tips{
                        margin-bottom:6px;
                        font-size: 12px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #FFE2BF;
                    }
                    img{
                        width:91px;
                        height:36px;
                    }
                }
            }
        }
        .bottom{
            width:calc(100% - 10px);
            height:28px;
            margin:0 auto;
            background-image: url('../../../assets/bottom.png');
            background-size: 100% 100%;
            position:relative;
            top:-1px;
        }
    }
</style>